class RetryError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export default RetryError;
